import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useApi } from '../hooks/useApi';
import { motion } from 'framer-motion';

const RegisterPage = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const api = useApi();

  const [formData, setFormData] = useState({ firstName: '', lastName: '', email: '', password: '', confirmPassword: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      const response = await api.post('/auth/register', formData);
      login(response.data.user, response.data.token);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.message || 'Application declined.');
    } finally {
      setLoading(false);
    }
  };

  const inputClass = "w-full bg-transparent border-b border-white/20 text-white px-0 py-3 text-sm font-light transition-colors duration-300 focus:outline-none focus:border-gold placeholder:text-white/20 tracking-wide";

  return (
    <div className="min-h-screen bg-deepDark flex items-center justify-center px-4 py-12 relative overflow-hidden">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold/5 blur-[120px] rounded-full pointer-events-none"></div>
      
      <motion.div 
        initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}
        className="w-full max-w-lg relative z-10"
      >
        <div className="text-center mb-10">
          <h1 className="text-4xl font-serif text-white tracking-wider mb-4">LuxeJewels</h1>
          <p className="text-[10px] tracking-widest uppercase text-textMuted">Client Application</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-surfaceDark border border-white/5 p-8 md:p-12 shadow-2xl space-y-6">
          <div className="grid grid-cols-2 gap-8">
            <input type="text" name="firstName" placeholder="First Name" value={formData.firstName} onChange={handleChange} className={inputClass} required />
            <input type="text" name="lastName" placeholder="Last Name" value={formData.lastName} onChange={handleChange} className={inputClass} required />
          </div>

          <input type="email" name="email" placeholder="Email Address" value={formData.email} onChange={handleChange} className={inputClass} required />
          <input type="password" name="password" placeholder="Passcode" value={formData.password} onChange={handleChange} className={inputClass} required />
          <input type="password" name="confirmPassword" placeholder="Confirm Passcode" value={formData.confirmPassword} onChange={handleChange} className={inputClass} required />

          {error && (
            <div className="text-red-500/80 text-[10px] tracking-widest uppercase border border-red-500/20 bg-red-500/5 p-3 text-center mt-4">
              {error}
            </div>
          )}

          <div className="pt-6">
            <button type="submit" disabled={loading} className="w-full bg-gold text-deepDark font-bold py-4 text-xs tracking-widest uppercase hover:bg-white transition-colors duration-300 disabled:opacity-50">
              {loading ? 'Processing...' : 'Submit Details'}
            </button>
          </div>
        </form>

        <p className="text-center mt-12 text-xs font-light tracking-wide text-textMuted">
          Already registered? <Link to="/login" className="text-gold uppercase tracking-widest text-[10px] font-bold hover:text-white transition-colors ml-2 border-b border-gold/30 hover:border-white">Sign In</Link>
        </p>
      </motion.div>
    </div>
  );
};

export default RegisterPage;
